"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickOutside = useClickOutside;

var _react = require("react");

var DEFAULT_EVENTS = ['mousedown', 'touchstart'];

function useClickOutside(handler) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      var _ref = event || {},
          target = _ref.target;

      if (ref.current && !ref.current.contains(target)) {
        handler();
      }
    };

    DEFAULT_EVENTS.forEach(function (fn) {
      return document.addEventListener(fn, listener);
    });
    return function () {
      DEFAULT_EVENTS.forEach(function (fn) {
        return document.removeEventListener(fn, listener);
      });
    };
  }, [ref, handler]);
  return ref;
}